import { Component, OnInit, AfterViewInit } from '@angular/core';
import { FileViewBase } from './file.view.directive';
import { FilesProvider, ImageReadyService } from './providers/';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

declare var JSM:any;
declare var THREE:any;


@Component({
  selector: 'file-view-3d',
  template: `
    <div style="width: 15%; float:left; overflow-y: scroll; height: 100%;">
      <ul>
        <li *ngFor="let mesh of meshes;let ind = index;">{{mesh.name}} <button (click)="showHideMesh(ind)">
        <ng-container *ngIf="meshVisibility[ind]">H</ng-container>
        <ng-container *ngIf="!meshVisibility[ind]">S</ng-container>
        </button></li>
      </ul>
    </div>
    <div id="modelWrapper" style="width: 85%; height: 100%; float:left;">
      <canvas id="model" width="200" height="200"></canvas>
    </div>
    <div class="menu-3d">
      <button></button>
    </div>
  `
})
export class FileView3dComponent extends FileViewBase implements OnInit, AfterViewInit {
  viewer: any;
  url: SafeResourceUrl;
  jsonData: any;
  meshes: any = [];
  meshVisibility: any = [];
  constructor(public fp: FilesProvider, public irs: ImageReadyService, private san: DomSanitizer) {
    super(fp, irs);
    this.irs.wait();
  }
  ngOnInit() {
    this.url = this.file.view(this.san, true);
  }
  ngAfterViewInit() {
    this.create3D();
  }

  resized(evt) {
    let canvas = <any>document.getElementById ('model');
    let wrapper = <any>document.getElementById('modelWrapper');
		canvas.width = wrapper.offsetWidth;
		canvas.height = wrapper.offsetHeight;
  }

  showHideMesh(meshIndex:number) {
    this.meshVisibility[meshIndex] = !this.meshVisibility[meshIndex];
    if (this.meshVisibility[meshIndex]) {
      this.ShowMesh(meshIndex);
    } else {
      this.HideMesh(meshIndex);
    }
    return this.meshVisibility[meshIndex];
  }

  private create3D() {
    this.resized(null);
    this.viewer = new JSM.ThreeViewer();
    let viewerSettings = {cameraEyePosition : [3.0, -3.0, 3.0],
				cameraCenterPosition : [0.0, 0.0, 0.0],
				cameraUpVector : [0.0, 0.0, 1.0]};
    this.viewer.Start(document.getElementById('model'), viewerSettings);
    this.viewer.SetClearColor (0xdddddd);
    this.viewer.Draw();
    let self = this;
    JSM.ConvertURLListToJsonData([this.file.view(this.san, true, false)], {
      onError: () => {
        alert('Error');
      },
      onReady: (fileNames, jsonData) => {
        this.jsonData = jsonData;
        this.viewer.RemoveMeshes();
        let meshes = JSM.ConvertJSONDataToThreeMeshes(jsonData, () => {
          this.viewer.Draw();
        });

        for (let i=0; i < meshes.length; i++) {
          this.viewer.AddMesh(meshes[i]);
        }
        this.viewer.AdjustClippingPlanes(50.0);
        this.viewer.FitInWindow();
        this.viewer.Draw();
        this.createMeshMenu();
        this.irs.done();
      }
    });
    this.viewer.Draw();
  }

  private createMeshMenu() {
    let json = JSM.MergeJsonDataMeshes(this.jsonData);
    this.meshes = this.jsonData.meshes;
    for (let i = 0; i < this.meshes.length; i++) {
      this.meshVisibility[i] = true;
    }
  }

  private HideMesh (index) {
  	var meshesToRemove = [];
  	var currentIndex = 0;
  	this.viewer.scene.traverse (function (current) {
  		if (current instanceof THREE.Mesh) {
  			if (current.originalJsonIndex == index) {
  				meshesToRemove.push (current);
  			}
  			currentIndex = currentIndex + 1;
  		}
  	});

  	let i, mesh;
  	for (i = 0; i < meshesToRemove.length; i++) {
  		mesh = meshesToRemove[i];
  		this.viewer.scene.remove (mesh);
  	}
  	this.viewer.Draw ();
  }

  private ShowMesh (index) {
  	let i, mesh;
  	let workJsonData = {
  		version : this.jsonData.version,
  		materials : this.jsonData.materials,
  		meshes : [this.jsonData.meshes[index]]
  	};

  	var meshes = JSM.ConvertJSONDataToThreeMeshes (workJsonData, this.viewer.Draw());
  	for (i = 0; i < meshes.length; i++) {
  		mesh = meshes[i];
  		mesh.originalJsonIndex = index;
  		this.viewer.AddMesh (mesh);
  	}

  	this.viewer.Draw ();
  }
}



// WEBPACK FOOTER //
// ./src/app/file.view.3d.component.ts